<!--
  global-search-adapter
  ─────────────────────────────────────────────────────────────────────────────
  Wrapper around student-search that acts as the single search entry point for
  the top navigation shell.  Keeping search behind this boundary means future
  search targets (schools, staff, etc.) can be added here without touching any
  upstream consumers.
-->
@if (vm$ | async; as vm) {
  <div [ngClass]="['global-search-adapter__mode-' + vm.searchState.searchMode]">
    @if (vm.searchState.searchMode === 'icon') {
      <nv-icon-button
        id="search-icon"
        isInverted="true"
        name="search-large-white"
        [ariaLabelData]="{ iconButtonAriaLabel: 'Open search' }"
        (clickButton)="toggleSearchMode()"
      ></nv-icon-button>
    }

    @if (vm.searchState.searchMode === 'bar' || vm.searchState.searchMode === 'full') {
      <ng-container [ngSwitch]="activeTarget">
        <ng-container *ngSwitchCase="'singleEntity'">
          @if (vm.searchOptions) {
            <student-search
              id="single-entity-search"
              [students]="vm.searchOptions"
              [placeholder]="vm.searchConfig.placeholder"
              [isDisabled]="vm.searchConfig.isDisabled"
              [isInverted]="true"
              [roundedCorner]="true"
              (selectedStudentId)="onResultSelected($event, activeTarget)"
            ></student-search>
          }
        </ng-container>

        <ng-container *ngSwitchCase="'multiEntity'">
          @if (vm.entityOptions) {
            <entity-search
              id="multi-entity-search"
              [entities]="vm.entityOptions"
              [placeholder]="vm.searchConfig.placeholder"
              [isDisabled]="vm.searchConfig.isDisabled"
              [isInverted]="true"
              [roundedCorner]="true"
              (selectedEntityId)="onResultSelected($event, activeTarget)"
            ></entity-search>
          }
        </ng-container>

        <div *ngSwitchDefault id="unsupported-search-target">Search target is not supported.</div>
      </ng-container>
    }

    @if (vm.searchState.searchMode === 'bar') {
      <nv-icon-button
        id="search-cancel-button"
        isInverted="true"
        name="close-large-white"
        [ariaLabelData]="{ iconButtonAriaLabel: 'Close search' }"
        (clickButton)="toggleSearchMode()"
      ></nv-icon-button>
    }
  </div>
}
